import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericDialogComponent } from './generic-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ButtonsModule } from '../buttons/buttons.module';
@NgModule({
  declarations: [GenericDialogComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatRippleModule,
    TranslateModule,
    MatDialogModule,
    MatButtonModule,
    ButtonsModule,
  ],
  exports: [GenericDialogComponent],
})
export class GenericDialogModule {}
